"use strict";
angular.module("iwoQuoteManuscriptModule", []).directive("iwoQuoteManuscript", ["$templateRequest", "$stateParams", "$compile", "$q", "editingCenterService", "editingMediatype", "trsHttpService", "modalDialog", "$filter", 'storageListenerService', '$state', function($templateRequest, $stateParams, $compile, $q, editingCenterService, editingMediatype, trsHttpService, modalDialog, $filter, storageListenerService, $state) {
    return {
        restrict: "A",
        replace: false,
        // templateUrl: "./editingCenter/myManuscript/personalManuscript/plannedOrderEdit/directive/iwoQuoteManuscript/iwoQuoteManuscript_tpl.html",
        scope: {
            callback: "&",
            seriesMetadataid: "=",
            seriesData: "=",
            sourceid: "="
        },
        link: function($scope, $element, attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    showQuoteManuscript: true,
                    serviceid: {
                        '15': 'mlf_tv',
                        '16': 'mlf_broadcast'
                    },
                    fusionServiceid: {
                        '15': 'mlf_tv',
                        '16': 'mlf_fusionbroadcast'
                    },
                    copyCurrPage: 1,
                }
                $scope.data = {
                    trenchList: [{
                        name: '电视',
                        value: 15
                    }, {
                        name: '广播',
                        value: 16
                    }],
                    selectedTrench: '',
                    columns: [{ name: '全部栏目', value: '' }],
                    quotes: [{ name: '全部', value: -1 }, { name: '已引用', value: 1 }, { name: '未引用', value: 0 }],
                    selectedQuote: { name: '全部', value: -1 },
                    selectedArray: []
                }
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 10
                }
                getTemplate();
                initElementClick();
                // initBlur();
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                var defaultChannel = $filter('filterBy')($scope.data.trenchList, ['value'], $scope.sourceid);
                $scope.data.selectedTrench = defaultChannel[0];
                getSites().then(function() {
                    return $scope.getAllChannels();
                }).then(function() {
                    requestData();
                });
            }
            /**
             * [queryChannelForMetadataid 查询串联单所属渠道]
             * @return {[type]} [description]
             */
            function queryChannelForMetadataid() {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_fusioncreate",
                    methodname: "queryDocMediaType",
                    ObjectId: $stateParams.iwometadataid
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.status.sourceid = data.MSG;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [initElementClick description] 初始化主元素的点击事件
             * @return {[type]} [description]
             */
            function initElementClick() {
                $element.bind("click", function() {
                    if (!$scope.status.showQuoteManuscript) {
                        $scope.status.showQuoteManuscript = true;
                        initData();
                    } else {
                        $scope.status.showQuoteManuscript = false;
                    }
                    $scope.$apply();
                    // console.log($scope.status.showQuoteManuscript);
                });
            }
            /**
             * [initElementEvent description] 初始化聚焦失焦事件
             * @return {[type]} [description]
             */
            function initBlur() {
                var blur = function(e) {
                    var $target = $(e.target);
                    if ($target[0] !== $element[0] && $target[0] !== $scope.status.template[0] && $target.parents(".precise_time_picker")[0] !== $scope.status.template[0] && $target.parents('.quoteManuscript_container')[0] !== $scope.status.template[0] && ($target.parents('.menu-list').length === 0 && $target.parents('.menu-list')[0] === $('.menu-list')[0])) {
                        $scope.status.showQuoteManuscript = false;
                    }
                }
                $("body").bind("mouseup", blur);
                $scope.$on("$destroy", function() {
                    $("body").unbind("mouseup", blur);
                });
            }
            /**
             * [getTemplate description] 获取模板
             * @return {[type]} [description]
             */
            function getTemplate() {
                $templateRequest("./editingCenter/iWo/myManuscript/personalManuscript/plannedOrderEdit/directive/iwoQuoteManuscript/iwoQuoteManuscript_tpl.html").then(function(template) {
                    $scope.status.template = $compile(template)($scope);
                    $("body").append($scope.status.template);
                    // initHoursMouseWheel();
                    // initMinutesMouseWheel();
                    // initSecondsMouseWheel();
                });
            }
            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    serviceid: $scope.status.serviceid[$scope.sourceid],
                    methodname: 'queryForChuanLianDocs',
                    SITEID: $scope.data.selectedSite.value,
                    CHANNELID: angular.isDefined($scope.data.selectedColumn) ? $scope.data.selectedColumn.value : '',
                    OperTimeStart: $scope.data.fromdate,
                    OperTimeEnd: $scope.data.untildate,
                    searchValue: $scope.status.keywords,
                    PageSize: $scope.page.PAGESIZE,
                    PageIndex: $scope.page.CURRPAGE,
                    Quote: $scope.data.selectedQuote.value == -1 ? '' : $scope.data.selectedQuote.value,
                    DocType: 9,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.quoteManuscirptData = data.DATA;
                    $scope.page = data.PAGER;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getSites description] 获取全部站点
             * @return {[type]} [description]
             */
            function getSites() {
                var defer = $q.defer();
                editingCenterService.querySitesByMediaType($scope.sourceid).then(function(data) {
                    $scope.data.sites = data.DATA.map(function(item) {
                        return {
                            name: item.SITEDESC,
                            value: item.SITEID
                        }
                    });
                    var siteid = $scope.seriesData.WEBSITEID;
                    var filterResult = $filter('filterBy')($scope.data.sites, ['value'], siteid);
                    $scope.data.selectedSite = filterResult[0];
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getAllChannels description] 获取对应产品下所有栏目
             * @return {[type]} [description]
             */
            $scope.getAllChannels = function(isRequestData) {
                var defer = $q.defer();
                var params = {
                    serviceid: $scope.status.serviceid[$scope.sourceid],
                    methodname: 'getAllChannelsOfYIQian',
                    webSiteId: $scope.data.selectedSite.value
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.columns = [{ name: '全部栏目', value: '' }];
                    if (Object.prototype.toString.call(data) == '[object Array]') {
                        var items = [];
                        angular.forEach(data, function(obj, index) {
                            items.push({
                                name: obj.CHNLDESC,
                                value: obj.CHANNELID
                            });
                        });
                        $scope.data.columns = $scope.data.columns.concat(items);
                        $scope.data.selectedColumn = $scope.data.columns[0];
                    }
                    if (angular.isDefined(isRequestData) && isRequestData) {
                        $scope.data.selectedArray = [];
                        requestData();
                    }
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [fullTextSearch description] 查询
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.data.selectedArray = [];
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            }
            /**
             * [pageChanged description] 翻页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                // $scope.status.params.CurrPage = $scope.page.CURRPAGE;
                // $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };
            /*跳转指定页面*/
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                // $scope.status.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };
            /**
             * [selectPageNum description]选择单页显示条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                requestData();
            };
            /**
             * [singleSelect description] 选择/取消选择
             * @param  {[type]} item [description] 广电文稿
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                if ($scope.isChecked(item)) {
                    $scope.data.selectedArray = $scope.data.selectedArray.filter((_item, index) => {
                        return item.METADATAID !== _item.METADATAID;
                    });
                } else {
                    $scope.data.selectedArray.push(item);
                }
            }
            /**
             * [selectAll description] 全选/全部取消
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.selectedArray.length == $scope.data.quoteManuscirptData.length && $scope.data.quoteManuscirptData.length > 0) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = angular.copy($scope.data.quoteManuscirptData);
                }
            }
            /**
             * [isChecked description] 稿件是否选中
             * @param  {[type]}  item [description] 稿件信息
             * @return {Boolean}      [description]
             */
            $scope.isChecked = function(item) {
                return $scope.data.selectedArray.some((_item, index) => {
                    return item.METADATAID == _item.METADATAID;
                });
            }
            /**
             * [batchQuote description] 批量引用
             * @return {[type]} [description]
             */
            $scope.batchQuote = function() {
                if ($scope.data.selectedArray.length == 0) {
                    modalDialog.alertType('请先选择引用广电文稿', '', 'info', false);
                    return;
                }
                var defer = $q.defer();
                if ($scope.data.selectedArray.length == 0) {
                    return;
                } else {
                    var params = {
                        serviceid: $scope.status.serviceid[$scope.sourceid],
                        methodname: 'saveQuoteDocs',
                        QuoteDocIds: $scope.data.selectedArray.map(function(item) {
                            return item.DOCID;
                        }).join(','),
                        SeriesDocId: $scope.seriesMetadataid
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        if (data.ISSUCCESS == "true") {
                            modalDialog.alertType('引用广电文稿成功！', '', 'success', false);
                            $scope.status.showQuoteManuscript = false;
                            $scope.callback();
                            $scope.data.selectedArray = [];
                        }
                        defer.resolve();
                    }, function() {
                        $scope.callback();
                        defer.reject();
                    });
                }
                return defer.promise;
            }
            /**
             * [close description] 关闭
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $scope.status.showQuoteManuscript = false;
            }
            /**
             * [requestData description] 数据请求
             * @return {[type]} [description]
             */
            $scope.requestData = function() {
                $scope.data.selectedArray = [];
                requestData();
            }

            /**
             * [preview 详情页跳转]
             * @param  {[type]} doctype       [description]
             * @param  {[type]} iwometadataid [description]
             * @param  {[type]} iwochannelid  [description]
             * @param  {[type]} CHANNELID     [description]
             * @param  {[type]} item          [description]
             * @return {[type]}               [description]
             */
            $scope.preview = function(doctype, iwometadataid, iwochannelid, CHANNELID, item) {
                var routerParams, url;
                if ($scope.sourceid == 15) {
                    storageListenerService.previewPageTurningStorage($scope.data.quoteManuscirptData, "METADATAID,CHNLDOCID,DOCTYPEID", "televisionPreview"); //iwo
                    routerParams = {
                        // iwoplatform: 0,
                        tvmetadataid: iwometadataid,
                        tvchannelid: iwochannelid,
                        tvsiteid: item.SITEID,
                        tvplatform: (item.DOCSTATUS == 1 || item.DOCSTATUS == 15) ? 0 : item.DOCSTATUS == 2 ? 1 : 2,
                        tvchannelid: CHANNELID,
                        // broadcastchannelid: iwochnldocid,
                        isfromplannedorder: true
                    };
                    url = $state.href('manuscriptPreview', routerParams);
                } else {
                    storageListenerService.previewPageTurningStorage($scope.data.quoteManuscirptData, "METADATAID,CHNLDOCID,DOCTYPEID", "broadcastPreview"); //iwo
                    routerParams = {
                        // iwoplatform: 0,
                        broadcastmetadataid: iwometadataid,
                        broadcastchannelid: iwochannelid,
                        broadcastsiteid: item.SITEID,
                        broadcastplatform: (item.DOCSTATUS == 1 || item.DOCSTATUS == 15 || item.DOCSTATUS == 3) ? 0 : item.DOCSTATUS == 2 ? 1 : 2,
                        broadcastchannelid: CHANNELID,
                        // broadcastchannelid: iwochnldocid,
                        isfromplannedorder: true
                    };
                    url = $state.href('broadcastmanuscriptPreview', routerParams);
                }
                item.url = url;
            };

        }
    }
}]);